import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q8 = [];

var entryPoint = [0, 0];

var selectedCount_Q8 = 0;

var routeMapSet_Q8 = 1;

var newPointDistanceQ8 = 0;

var plantArrayQ8 = [[], [], [], [], [], [], [], [], [], [], [], [], []];

var plantLeftArrayQ8 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q8 = new Phaser.Geom.Point(330, -200);

var leftQ8_p1 = new Phaser.Geom.Point(258, 205);
var leftQ8_p2 = new Phaser.Geom.Point(190, 320);
var leftQ8_p3 = new Phaser.Geom.Point(262, 441);
var leftQ8_p4 = new Phaser.Geom.Point(390, 441);
var leftQ8_p5 = new Phaser.Geom.Point(460, 320);

var array1_Q8 = [];

var leftExitWay_Q8 = new Phaser.Geom.Point(330, 1000);

var leftFinalRouteMap_Q8 = [leftEntrance_Q8, leftQ8_p1, leftQ8_p2, leftQ8_p3, leftQ8_p4, leftQ8_p5, leftExitWay_Q8];

var leftRouteMapSet_Q8 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q8 = new Phaser.Geom.Point(0, 0);

var exitWay_Q8 = new Phaser.Geom.Point(0, 0);

var centerQ8 = new Phaser.Geom.Point(961.55, 323);

var startPointQ8 = new Phaser.Geom.Point(961.55, 190);

var firstClickPoint_Q8 = [];

var Q8_p1 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p2 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p3 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p4 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p5 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p6 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p7 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p8 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p9 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p10 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p11 = new Phaser.Geom.Point(1016.1, 159.3);
var Q8_p12 = new Phaser.Geom.Point(1016.1, 159.3);

// debugger

var coordinateArrayQ8 = [Q8_p1, Q8_p2, Q8_p3, Q8_p4, Q8_p5, Q8_p6, Q8_p7, Q8_p8, Q8_p9, Q8_p10, Q8_p11, Q8_p12];

export default class GameSceneQ8 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ8",
    });
  }

  preload() {
    this.load.image("BGQ8", "assets/Q8/BGQ8.png");

    this.load.image("D_BGQ8", "assets/Q8/D_BGQ8.png");
    this.load.image("L_curbQ8", "assets/Q8/L_curbQ8.png");

    this.load.image("curbQ8", "assets/Q8/curbQ8.png");
    this.load.image("rightPlotQ8", "assets/Q8/rightPlotQ8.png");

    this.load.image("hitBoxQ8_1", "assets/Q8/hitBoxQ8_1.png");
    this.load.image("hitBoxQ8_2", "assets/Q8/hitBoxQ8_2.png");

    this.load.image("whiteBoxQ8_1", "assets/Q8/whiteBoxQ8_1.png");
    this.load.image("whiteBoxQ8_2", "assets/Q8/whiteBoxQ8_2.png");

    this.load.image("leftGreyBoxQ8", "assets/Q8/leftGreyBoxQ8.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    for (let i = 0; i < coordinateArrayQ8.length; i++) {
      Phaser.Math.RotateAround(coordinateArrayQ8[i], 961.55, 323, i * Phaser.Math.DegToRad(30));
    }

    this.BGQ8 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ8");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.scoreRefresh();

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ8 = this.add.sprite(719, 51, "L_curbQ8").setOrigin(0).setDepth(2);
    this.add.sprite(678, 40, "rightPlotQ8").setOrigin(0).setDepth(2);

    this.hitBoxQ8_1 = this.add.sprite(960.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(0).setDepth(2);
    this.hitBoxQ8_2 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(0).setDepth(2);
    this.hitBoxQ8_3 = this.add.sprite(961.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(60).setDepth(2);
    this.hitBoxQ8_4 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(60).setDepth(2);
    this.hitBoxQ8_5 = this.add.sprite(961.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(120).setDepth(2);
    this.hitBoxQ8_6 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(120).setDepth(2);
    this.hitBoxQ8_7 = this.add.sprite(962.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(180).setDepth(2);
    this.hitBoxQ8_8 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(180).setDepth(2);
    this.hitBoxQ8_9 = this.add.sprite(962.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(240).setDepth(2);
    this.hitBoxQ8_10 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(240).setDepth(2);
    this.hitBoxQ8_11 = this.add.sprite(961.55, 323, "hitBoxQ8_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(300).setDepth(2);
    this.hitBoxQ8_12 = this.add.sprite(961.55, 323, "hitBoxQ8_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(300).setDepth(2);

    this.whiteBoxQ8_1 = this.add.sprite(960, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ8_2 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ8_3 = this.add.sprite(961.55, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(60).setDepth(2);
    this.whiteBoxQ8_4 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(60).setDepth(2);
    this.whiteBoxQ8_5 = this.add.sprite(961.55, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(120).setDepth(2);
    this.whiteBoxQ8_6 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(120).setDepth(2);
    this.whiteBoxQ8_7 = this.add.sprite(962.55, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(180).setDepth(2);
    this.whiteBoxQ8_8 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(180).setDepth(2);
    this.whiteBoxQ8_9 = this.add.sprite(962.55, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(240).setDepth(2);
    this.whiteBoxQ8_10 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(240).setDepth(2);
    this.whiteBoxQ8_11 = this.add.sprite(961.55, 323, "whiteBoxQ8_1").setOrigin(0, 1).setVisible(false).setAngle(300).setDepth(2);
    this.whiteBoxQ8_12 = this.add.sprite(961.55, 323, "whiteBoxQ8_2").setOrigin(0, 1).setVisible(false).setAngle(300).setDepth(2);

    this.leftGreyBoxQ8 = this.add.sprite(111, 85, "leftGreyBoxQ8").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.Q8_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q8_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q8_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q8_leftDr = this.add.text(78, 578, "6", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q8_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q8_rightDr = this.add.text(715, 578, "12", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.85, 0.9).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    // this.Q8_qn = this.add.sprite(20.14,473.2, "qnBoard").setOrigin(0);
    // this.Q8_ans = this.add.sprite(654.14,474.2, "ansBoard").setOrigin(0);

    this.anims.create({
      key: "floweringQ8",
      frames: this.anims.generateFrameNames("flowering1Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "FLOWER",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    this.waterPlantOnLeftQ8();

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    ////>

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(Q8_p1.x, Q8_p1.y, 4);
    // graphics.fillCircle(Q8_p2.x, Q8_p2.y, 4);
    // graphics.fillCircle(Q8_p3.x, Q8_p3.y, 4);
    // graphics.fillCircle(Q8_p4.x, Q8_p4.y, 4);
    // graphics.fillCircle(Q8_p5.x, Q8_p5.y, 4);
    // graphics.fillCircle(Q8_p6.x, Q8_p6.y, 4);
    // graphics.fillCircle(Q8_p7.x, Q8_p7.y, 4);
    // graphics.fillCircle(Q8_p8.x, Q8_p8.y, 4);
    // graphics.fillCircle(Q8_p9.x, Q8_p9.y, 4);
    // graphics.fillCircle(Q8_p10.x, Q8_p10.y, 4);
    // graphics.fillCircle(Q8_p11.x, Q8_p11.y, 4);
    // graphics.fillCircle(Q8_p12.x, Q8_p12.y, 4);
  }

  waterPlantOnLeftQ8() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ8.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q8[0].x, leftFinalRouteMap_Q8[0].y, leftFinalRouteMap_Q8[1].x, leftFinalRouteMap_Q8[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ8() {
    // ////>//>>>hidden_console.log("startQ8");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q8[leftRouteMapSet_Q8-1],leftRouteMapSet_Q8-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q8[leftRouteMapSet_Q8 - 1], leftRouteMapSet_Q8 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (leftRouteMapSet_Q8 < leftFinalRouteMap_Q8.length - 1) {
          this.Q8_leftNr.setText(leftRouteMapSet_Q8);

          this.moveCanInitial(leftFinalRouteMap_Q8[leftRouteMapSet_Q8].x, leftFinalRouteMap_Q8[leftRouteMapSet_Q8].y, leftFinalRouteMap_Q8[leftRouteMapSet_Q8 + 1].x, leftFinalRouteMap_Q8[leftRouteMapSet_Q8 + 1].y);

          leftRouteMapSet_Q8 = leftRouteMapSet_Q8 + 1;
          ////>//>>>hidden_console.log(leftRouteMapSet_Q8);
        } else {
          this.Q8_leftNr.setVisible(true);
          this.Q8_input.setVisible(true);

          this.startQuestionQ8();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ8.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ8[k5].length; l5++) {
        plantLeftArrayQ8[k5][l5].setTexture("flowering1Anim").play("floweringQ8");

        ////>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ8[1][1].setTexture("flowering1Anim").play("floweringQ8");

    for (var k = 0; k < plantArrayQ8.length; k++) {
      for (var l = 0; l < plantArrayQ8[k].length; l++) {
        plantArrayQ8[k][l].setTexture("flowering1Anim").play("floweringQ8");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ8");
    //   this.scene.start('GameSceneQ9');

    // },[],this);

    this.changeScene();
  }

  changeScene() {
    // debugger
    ////>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();
            attempts = 0;

            this.wipeSceneQ8();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ8");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ8");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ8");
              this.scene.start("GameSceneQ9");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        if (gameState.attempted == 10) {
          gameState.gameWin = false;
          // this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
      },
      [],
      this
    );
  }

  wipeSceneQ8() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q8 = [];

    entryPoint = [0, 0];

    selectedCount_Q8 = 0;

    routeMapSet_Q8 = 1;

    newPointDistanceQ8 = 0;

    plantArrayQ8 = [[], [], [], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ8 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q8 = [leftEntrance_Q8,leftQ8_p1,leftExitWay_Q8];
    leftRouteMapSet_Q8 = 1;

    entrance_Q8.setTo(0, 0);

    exitWay_Q8.setTo(0, 0);

    Q8_p1.setTo(1016.1, 159.3);
    Q8_p2.setTo(1016.1, 159.3);
    Q8_p3.setTo(1016.1, 159.3);
    Q8_p4.setTo(1016.1, 159.3);
    Q8_p5.setTo(1016.1, 159.3);
    Q8_p6.setTo(1016.1, 159.3);
    Q8_p7.setTo(1016.1, 159.3);
    Q8_p8.setTo(1016.1, 159.3);
    Q8_p9.setTo(1016.1, 159.3);
    Q8_p10.setTo(1016.1, 159.3);
    Q8_p11.setTo(1016.1, 159.3);
    Q8_p12.setTo(1016.1, 159.3);

    array1_Q8 = [];
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q8 += 1;

      this.Q8_input.setText(selectedCount_Q8);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(array1_Q8, this.getPointFromCode(xcode, ycode));

      selectedCount_Q8 -= 1;
      this.Q8_input.setText(selectedCount_Q8);

      ////>//>>>hidden_console.log(finalRouteMap_Q8);
    }
  }

  updateRouteMap(xcode, ycode) {
    // if(firstClickPoint_Q8.length == 0){
    // firstClickPoint_Q8.push(this.getPointFromCode(xcode,ycode));

    // }else{
    // array1_Q8.push(this.getPointFromCode(xcode,ycode));
    // }

    array1_Q8.push(this.getPointFromCode(xcode, ycode));

    //>//>>>hidden_console.log(array1_Q8);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q8_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q8_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q8_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q8_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q8_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q8_p6;
    } else if (xcode == 0 && ycode == 3) {
      return Q8_p7;
    } else if (xcode == 1 && ycode == 3) {
      return Q8_p8;
    } else if (xcode == 0 && ycode == 4) {
      return Q8_p9;
    } else if (xcode == 1 && ycode == 4) {
      return Q8_p10;
    } else if (xcode == 0 && ycode == 5) {
      return Q8_p11;
    } else if (xcode == 1 && ycode == 5) {
      return Q8_p12;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    // ////>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  pathFinding() {
    finalRouteMap_Q8.push(array1_Q8[0]);

    array1_Q8.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Q8)

    for (let i = 0; i < finalRouteMap_Q8.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Q8.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap_Q8[i][0] - array1_Q8[j][0], 2) + Math.pow(finalRouteMap_Q8[i][1] - array1_Q8[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q8[i], array1_Q8[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap_Q8.push(array1_Q8[index]);
      array1_Q8.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap_Q8);

      if (finalRouteMap_Q8.length == 10) {
        break;
      }
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();
      ////

      if (selectedCount_Q8 == 10) {
        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        this.pathFinding();
        //>2

        //>//>>>hidden_console.log(finalRouteMap_Q8);
        //>//>>>hidden_console.log(array1_Q8);

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        ////>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q8_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q8[0] == Q8_p1) {
          entrance_Q8.setTo(727, -200);
        } else if (finalRouteMap_Q8[0] == Q8_p2) {
          entrance_Q8.setTo(844, -200);
        } else if (finalRouteMap_Q8[0] == Q8_p3) {
          entrance_Q8.setTo(961, -200);
        } else if (finalRouteMap_Q8[0] == Q8_p4) {
          entrance_Q8.setTo(2078, 203);
        } else if (finalRouteMap_Q8[0] == Q8_p5) {
          entrance_Q8.setTo(727, 900);
        } else if (finalRouteMap_Q8[0] == Q8_p6) {
          entrance_Q8.setTo(844, 900);
        } else if (finalRouteMap_Q8[0] == Q8_p7) {
          entrance_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[0] == Q8_p8) {
          entrance_Q8.setTo(2078, 326);
        } else if (finalRouteMap_Q8[0] == Q8_p9) {
          entrance_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[0] == Q8_p10) {
          entrance_Q8.setTo(2078, 326);
        } else if (finalRouteMap_Q8[0] == Q8_p11) {
          entrance_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[0] == Q8_p12) {
          entrance_Q8.setTo(2078, 326);
        }

        finalRouteMap_Q8.unshift(entrance_Q8);

        if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p1) {
          exitWay_Q8.setTo(727, -200);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p2) {
          exitWay_Q8.setTo(844, -200);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p3) {
          exitWay_Q8.setTo(961, -200);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p4) {
          exitWay_Q8.setTo(2078, 203);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p5) {
          exitWay_Q8.setTo(727, 900);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p6) {
          exitWay_Q8.setTo(844, 900);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p7) {
          exitWay_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p8) {
          exitWay_Q8.setTo(2078, 326);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p9) {
          exitWay_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p10) {
          exitWay_Q8.setTo(2078, 326);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p11) {
          exitWay_Q8.setTo(961, 900);
        } else if (finalRouteMap_Q8[finalRouteMap_Q8.length - 1] == Q8_p12) {
          exitWay_Q8.setTo(2078, 326);
        }

        finalRouteMap_Q8.push(exitWay_Q8);

        // debugger
        this.moveCan(finalRouteMap_Q8[0].x, finalRouteMap_Q8[0].y, finalRouteMap_Q8[1].x, finalRouteMap_Q8[1].y);
      } else {
        //>3

        config.audio.wrongAnswer.play();

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        // this.Q8_ans.setTint(0xFFC2A2);

        this.Q8_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q8_rightDr.setFill("#C22300");
        this.Q8_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q8_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q8_rightDr.setFill("#2b2b2b");
            this.Q8_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    ////>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q8[routeMapSet_Q8 - 1], routeMapSet_Q8 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q8 < finalRouteMap_Q8.length - 1) {
          this.moveCan(finalRouteMap_Q8[routeMapSet_Q8].x, finalRouteMap_Q8[routeMapSet_Q8].y, finalRouteMap_Q8[routeMapSet_Q8 + 1].x, finalRouteMap_Q8[routeMapSet_Q8 + 1].y);

          routeMapSet_Q8 = routeMapSet_Q8 + 1;
          ////>//>>>hidden_console.log(routeMapSet_Q8);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }

  scoreRefresh() {
    // ////>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }
  showDeselect() {
    if (selectedCount_Q8 >= 10) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(array1_Q8[0].x, array1_Q8[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  hitboxClickAndHoverHandle() {
    this.BGQ8.setTexture("BGQ8");
    this.curbQ8.setTexture("curbQ8");

    this.hitBoxQ8_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_1, 0, 0);
      },
      this
    );
    this.hitBoxQ8_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_2, 1, 0);
      },
      this
    );
    this.hitBoxQ8_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_3, 0, 1);
      },
      this
    );
    this.hitBoxQ8_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_4, 1, 1);
      },
      this
    );
    this.hitBoxQ8_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_5, 0, 2);
      },
      this
    );
    this.hitBoxQ8_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_6, 1, 2);
      },
      this
    );
    this.hitBoxQ8_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_7, 0, 3);
      },
      this
    );
    this.hitBoxQ8_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_8, 1, 3);
      },
      this
    );
    this.hitBoxQ8_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_9, 0, 4);
      },
      this
    );
    this.hitBoxQ8_10.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_10, 1, 4);
      },
      this
    );
    this.hitBoxQ8_11.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_11, 0, 5);
      },
      this
    );
    this.hitBoxQ8_12.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ8_12, 1, 5);
      },
      this
    );

    this.hitBoxQ8_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(1);
      },
      this
    );
    this.hitBoxQ8_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(2);
      },
      this
    );
    this.hitBoxQ8_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(3);
      },
      this
    );
    this.hitBoxQ8_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(4);
      },
      this
    );
    this.hitBoxQ8_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(5);
      },
      this
    );
    this.hitBoxQ8_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(6);
      },
      this
    );
    this.hitBoxQ8_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(7);
      },
      this
    );
    this.hitBoxQ8_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(8);
      },
      this
    );
    this.hitBoxQ8_9.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(9);
      },
      this
    );
    this.hitBoxQ8_10.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(10);
      },
      this
    );
    this.hitBoxQ8_11.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(11);
      },
      this
    );
    this.hitBoxQ8_12.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ8(12);
      },
      this
    );

    this.hitBoxQ8_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_9.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_10.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_11.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
    this.hitBoxQ8_12.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ8();
      },
      this
    );
  }

  enableClicking() {
    this.hitBoxQ8_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_8.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_9.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_10.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_11.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ8_12.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ8_1.removeInteractive();
    this.hitBoxQ8_2.removeInteractive();
    this.hitBoxQ8_3.removeInteractive();
    this.hitBoxQ8_4.removeInteractive();
    this.hitBoxQ8_5.removeInteractive();
    this.hitBoxQ8_6.removeInteractive();
    this.hitBoxQ8_7.removeInteractive();
    this.hitBoxQ8_8.removeInteractive();
    this.hitBoxQ8_9.removeInteractive();
    this.hitBoxQ8_10.removeInteractive();
    this.hitBoxQ8_11.removeInteractive();
    this.hitBoxQ8_12.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }
    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ8(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ8();

    if (position == 1) {
      this.whiteBoxQ8_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ8_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ8_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ8_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ8_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ8_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ8_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ8_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBoxQ8_9.setVisible(true);
    }
    if (position == 10) {
      this.whiteBoxQ8_10.setVisible(true);
    }
    if (position == 11) {
      this.whiteBoxQ8_11.setVisible(true);
    }
    if (position == 12) {
      this.whiteBoxQ8_12.setVisible(true);
    }
  }

  removeWhiteBoxQ8() {
    this.whiteBoxQ8_1.setVisible(false);
    this.whiteBoxQ8_2.setVisible(false);
    this.whiteBoxQ8_3.setVisible(false);
    this.whiteBoxQ8_4.setVisible(false);
    this.whiteBoxQ8_5.setVisible(false);
    this.whiteBoxQ8_6.setVisible(false);
    this.whiteBoxQ8_7.setVisible(false);
    this.whiteBoxQ8_8.setVisible(false);
    this.whiteBoxQ8_9.setVisible(false);
    this.whiteBoxQ8_10.setVisible(false);
    this.whiteBoxQ8_11.setVisible(false);
    this.whiteBoxQ8_12.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    if (selectedPoint == Q8_p1) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y + 40, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p2) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p3) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p4) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 30, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 80, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p5) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 55, selectedPoint.y - 100, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p6) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 100, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p7) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 20, selectedPoint.y - 80, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p8) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p9) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 0, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 60, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p10) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 35, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p11) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 40, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 20, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q8_p12) {
      plantArrayQ8[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ8[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 25, selectedPoint.y + 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    }

    // plantArrayQ8[plantSelectionCode][2] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantArrayQ8[plantSelectionCode][3] = this.add.sprite(selectedPoint.x + 105,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    plantLeftArrayQ8[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x - 0, selectedPoint.y + 15, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false);
    plantLeftArrayQ8[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x - 0, selectedPoint.y - 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ8[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 30, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ8[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x - 40, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");

    // plantLeftArrayQ8[plantSelectionCode][4] = this.add.sprite(selectedPoint.x + 40,selectedPoint.y + 10,"playSwayAnim").setScale(0.3).play("plantbudding");

    // plantLeftArrayQ8[plantSelectionCode][5] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 75,"playSwayAnim").setScale(0.3).play("plantbudding");
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q8 <= selectedCount_Q8 || leftRouteMapSet_Q8 < leftFinalRouteMap_Q8.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
